// @ts-nocheck
import React from 'react';
import appConst from '../Utilities/appConst.json';
import ShippingMethod from '../Components/ShippingMethod';
import { useSelector } from 'react-redux';
import "../styles/subShipping.css";
import Shops from '../Components/Shops';
import Asafta from '../Components/Asafta';
import useBrazeScreenView from '../hooks/useBrazeScreenView';
import PageLayout from "../Components/PageLayout";

const SubShipping = () => {
    const shippingMethods = useSelector((state: any) => state.shipping.shippingMethods);
    const selectedId = useSelector((state: any) => state.shipping.selectedId);
    const selectedMethod = shippingMethods.find((e: any) => e.id == selectedId);
    useBrazeScreenView();

    return (
        <PageLayout className='sub_shipping_page'>
            <div className='sub_shipping'>
                <div className='shipping_method'>
                    {selectedMethod && <ShippingMethod
                            option={selectedMethod}
                            isChecked={false}
                        />
                    }</div>
                <div>
                    {selectedMethod && selectedMethod.id.toString() === appConst.BHSHOPS && <Shops />}
                    {selectedMethod && selectedMethod.id.toString() === appConst.ASAFTA && <Asafta />}
                </div>
            </div>
        </PageLayout>
    )
}
export default SubShipping;
